var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close-button",attrs:{"name":_vm.name,"aria-label":_vm.$t('closeModal'),"role":"button"},on:{"mousedown":function($event){$event.preventDefault();}}},[_c('svgicon',{attrs:{"name":"modal-close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }